import { FC } from 'react'
import { green, red, grey } from '@material-ui/core/colors'
import IconDeviceWarning from '../../assets/images/icons/iconDeviceWarning.svg?react'
import IconDevice from '../../assets/images/icons/2faIcon.svg?react'
import { TwoFaMobileProgressStatus } from '../../graphql'

const colorMap = {
  pending: grey[500],
  success: green[500],
  error: red[500],
}

const getColor = (status: TwoFaMobileProgressStatus) => colorMap[status]

export const TwoFaIcon: FC<{
  status: TwoFaMobileProgressStatus
}> = ({ status }) => {
  return status !== 'error' ? (
    <IconDevice style={{ color: getColor(status) }} />
  ) : (
    <IconDeviceWarning style={{ color: getColor(status) }} />
  )
}
